export default __webpack_public_path__ + "static/media/practice-test-1.141bbd44.csv";